import home from './home';
import print from './print';

export const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/login',
    // redirect: '/dashboard/landing',
    children: [...home],
    meta: {
      name: 'home',
      isMenu: false,
    },
  },
  {
    path: '/dashboard/landing',
    component: () => import('@/page/Dashboard.vue'),
    meta: {
      name: '대시보드 랜딩페이지',
      isMenu: false,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/page/Login.vue'),
    meta: {
      name: 'login',
    },
  },
  {
    path: '/print',
    children: [...print],
  },
  {
    path: '/main/landing',
    component: () => import('@/page/Dashboard.vue'),
    redirect: '/dashboard/landing',
    meta: {
      name: 'PC 전환 랜딩페이지',
      isMenu: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/page/Error.vue'),
    children: [],
    meta: {
      name: '404',
      isMenu: false,
    },
  },
];
